import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import getCurrentUser from "../common/GetCurrentUser";
import SignupModal from "./SignupModal";
import { sendRequest } from "../../ApiRequest";
import { BASE_URL } from "../../URL/constants";

const Signup = () => {
  const [activeTab, setActiveTab] = useState("login");
  const [showOtpLogin, setShowOtpLogin] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  const navigate = useNavigate();
  const { loginUser } = getCurrentUser();

  useEffect(() => {
    const modal = new window.bootstrap.Modal(document.getElementById("signupModal"));
    modal.show();
  }, []);

  const closeModal = () => {
    const modal = window.bootstrap.Modal.getInstance(document.getElementById("signupModal"));
    modal.hide();
  };

  const handleSendOtp = async () => {
    try {
      const response = await sendRequest(
        "POST",
        `${BASE_URL}/v1/public_site/customers/send_otp`,
        { customer: { login: phoneNumber } }
      );
      setShowOtpLogin(true);
      console.log("OTP sent:", response);
    } catch (error) {
      // alert("Failed to send OTP");
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const response = await sendRequest(
        "POST",
        `${BASE_URL}/v1/public_site/customers/verify_otp`,
        { customer: { login: phoneNumber, otp } }
      );

      if (response.data.message === "Login successful") {
        localStorage.setItem("authToken", response.data.token);
        localStorage.setItem("userDetails", JSON.stringify(response.data.customer));
        loginUser(response);

        // Guest cart sync
        const guestCart = JSON.parse(localStorage.getItem("guestCart")) || {};
        const guestCartItems = Array.isArray(guestCart) ? guestCart : Object.values(guestCart);
        if (guestCartItems.length > 0 && response.data.customer?.id) {
          const itemsToSync = guestCartItems.map(item => ({
            item_id: item.item_id || item.id,
            quantity: item.quantity || 1
          }));

          try {
            await sendRequest(
              "POST",
              `${BASE_URL}/v1/public_site/customers/${response.data.customer.id}/cart/sync_guest_cart`,
              { items: itemsToSync },
              { Authorization: response.data.token }
            );
            localStorage.removeItem("guestCart");
            // Dispatch cart-updated event to update cart count immediately
            window.dispatchEvent(new Event('cart-updated'));
          } catch (syncError) {
            console.error("Error syncing guest cart:", syncError);
          }
        }

        // Close modal and redirect
        const modalElement = document.getElementById("signupModal");
        const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
          modalInstance.hide();
        }
        
        // Wait for modal to close before redirecting
        setTimeout(() => {
          window.location.href = "/";
        }, 300);
      } else {
        // New user - switch to signup
        setActiveTab("signup");
      }
    } catch (error) {
      console.log("Error verifying OTP:", error);
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    try {
      const response = await sendRequest(
        "POST",
        `${BASE_URL}/v1/public_site/customers/sign_up`,
        {
          customer: {
            first_name: firstName,
            last_name: lastName,
            email,
            phone: phoneNumber,
          },
        }
      );
      
      // Store auth data if provided
      if (response.data.token) {
        localStorage.setItem("authToken", response.data.token);
        localStorage.setItem("userDetails", JSON.stringify(response.data.customer));
        loginUser(response);
      }
      
      // Close modal properly
      const modalElement = document.getElementById("signupModal");
      const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      }
      
      // Wait for modal to close before redirecting
      setTimeout(() => {
        window.location.href = "/";
      }, 300);
    } catch (error) {
      console.error("Signup failed:", error);
    }
  };

  return (
    <SignupModal
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      showOtpLogin={showOtpLogin}
      setShowOtpLogin={setShowOtpLogin}
      handleSignUp={handleSignUp}
      handleSendOtp={handleSendOtp}
      handleVerifyOtp={handleVerifyOtp}
      phoneNumber={phoneNumber}
      setPhoneNumber={setPhoneNumber}
      otp={otp}
      setOtp={setOtp}
      firstName={firstName}
      setFirstName={setFirstName}
      lastName={lastName}
      setLastName={setLastName}
      email={email}
      setEmail={setEmail}
    />
  );
};

export default Signup;
